var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconShared(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-shared",
    transform: "translate(-29 -358)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg-transp",
    width: 20,
    height: 20,
    transform: "translate(29 358)",
    fill: "#96969f",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-shared-gray",
    transform: "translate(26.629 356.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M25.142,2.45A3.192,3.192,0,1,1,21.95,5.642,3.2,3.2,0,0,1,25.142,2.45Zm0,5.229A2.037,2.037,0,1,0,23.1,5.642,2.04,2.04,0,0,0,25.142,7.679Z",
    transform: "translate(-7.542 0)",
    fill: "#96969f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M7.142,12.95A3.192,3.192,0,1,1,3.95,16.142,3.2,3.2,0,0,1,7.142,12.95Zm0,5.229A2.037,2.037,0,1,0,5.1,16.142,2.04,2.04,0,0,0,7.142,18.179Z",
    transform: "translate(0 -4.399)",
    fill: "#96969f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M25.142,23.45a3.192,3.192,0,1,1-3.192,3.192A3.2,3.2,0,0,1,25.142,23.45Zm0,5.229A2.037,2.037,0,1,0,23.1,26.642,2.04,2.04,0,0,0,25.142,28.679Z",
    transform: "translate(-7.542 -8.799)",
    fill: "#96969f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M18.864,24.338a.574.574,0,0,1-.29-.079l-5.952-3.469a.577.577,0,1,1,.581-1l5.952,3.469a.577.577,0,0,1-.291,1.076Z",
    transform: "translate(-3.513 -7.234)",
    fill: "#96969f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M12.913,13.838a.577.577,0,0,1-.291-1.076l5.944-3.469a.577.577,0,1,1,.582,1L13.2,13.759A.575.575,0,0,1,12.913,13.838Z",
    transform: "translate(-3.513 -2.835)",
    fill: "#96969f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShared);
export default __webpack_public_path__ + "static/media/icon-shared.922491e8721f4fc8bee6e5f605029671.svg";
export { ForwardRef as ReactComponent };